import * as React from 'react'
import { GridCellProps } from '@progress/kendo-react-grid'
import { formatDate } from '@telerik/kendo-intl';
import SystemSwitch from '../inputs/SystemSwitch';
import { UTCToLocalDateTime, UTCToLocalDate } from './../helpers/utils'
import httpService from '../../service/httpService';
export class DateCell extends React.Component<GridCellProps> {

    isValidDate = (dateObject: any) => new Date(dateObject).toString() !== 'Invalid Date';

    render() {
        let value = this.props.dataItem[this.props.field as string];
        let text = '';
        if (value != null && value != undefined && this.isValidDate(value)) text = formatDate(new Date(value), setting.dateFormat)

        return (<td>{text}</td>);
    }
}


export class PasswordCell extends React.Component<GridCellProps> {
    render() {
        let value = this.props.dataItem[this.props.field as string];
        let text = '';
        var lengthvalue = value.length;

        for (var i = 0; i < value.length; i++) {
            text = text + '*';
        }
        //if (value != null && value != undefined && this.isValidDate(value)) text = formatDate(new Date(value), setting.dateFormat)

        return (<td>{text}</td>);
    }
}

export class DateTimeCell extends React.Component<GridCellProps> {
    render() {
        const value = this.props.dataItem[this.props.field as string];
        if (value != "" && value != undefined) {
            return (<td>{UTCToLocalDateTime(value)}</td>);
        }
        else {
            return (<td>{""}</td>);

        }
    }
}
export class DateCellOnly extends React.Component<GridCellProps> {
    render() {
        const value = this.props.dataItem[this.props.field as string];
        if (value != "" && value != undefined) {
            return (<td>{UTCToLocalDate(value)}</td>);
        }
        else {
            return (<td>{""}</td>);

        }
    }
}

interface ISwitchCellProps {
    url?: string
    PrimaryKey?: string
    FieldName?: string
    onValueChanged?(response: any): void
}
let _this: object;
export class SwitchCell extends React.Component<GridCellProps & ISwitchCellProps> {

    constructor(props: any) {
        super(props);
        this.onChange = this.onChange.bind(this);
        _this = this;
    }
    onChange = (event: any) => {
        if (this.props.url) {
            let value = event.target.value;
            let data = {
                PrimaryKeyEncrypted: this.props.PrimaryKey,
                FieldName: this.props.FieldName,
                FieldValue: value
            };
            var response = httpService.post(this.props.url, data);
            this.props.onValueChanged && this.props.onValueChanged(response)
        }
    }

    render() {
        const value = this.props.dataItem[this.props.field as string];
        return (<td><SystemSwitch value={value} hideLabel={true} onChange={this.onChange} /></td>);
    }
}


interface IButtonCellProps {
    url?: string
    trueCaption?: string
    falseCaption?: string
    captions?: { value: any, text: string }[]
    PrimaryKey?: string
    FieldName?: string
    onValueChanged?(response: any): void
}
export class ButtonCell extends React.Component<GridCellProps & IButtonCellProps> {
    onClick = async (event: any) => {
        if (this.props.url) {
            this.setState({ value: !this.state.value }, async () => {
                var response = await httpService.post(this.props.url, { PrimaryKey: this.props.PrimaryKey, FieldName: this.props.FieldName, FieldValue: this.state.value });
                this.props.onValueChanged && this.props.onValueChanged(response)
            })
        }
    }

    state = {
        value: this.props.dataItem[this.props.field as string]
    };

    constructor(props: any) {
        super(props)
    }

    getCaption = () => {
        const value = this.props.dataItem[this.props.field as string];
        if (this.props.trueCaption && this.state.value) return this.props.trueCaption;
        if (this.props.falseCaption && !this.state.value) return this.props.falseCaption;

        if (this.props.captions) {
            let caption = this.props.captions.find((item) => item.value == value);
            if (caption) return caption.text;
        }


        return '';
    }

    render() {
        return (<td><button value={this.state.value} onClick={this.onClick}>{this.getCaption()}</button></td>);
    }
}
export class CheckCell extends React.Component<GridCellProps> {
    render() {
        const value = this.props.dataItem[this.props.field as string];
        return (<td> {value ? <span className="icon-check"></span> : null} </td>)
    }
}

export class CheckCrossCell extends React.Component<GridCellProps> {

    render() {
        const value = this.props.dataItem[this.props.field as string];
        return (<td> {value == 1 ? <span className="icon-check"></span> : <span className='icon-close'> </span>} </td>)
    }
}

export class UserStatusCell extends React.Component<GridCellProps> {

    render() {
        const value = this.props.dataItem[this.props.field as string];
        return (<td> {value == 'Available' ? <span className="profile_status_active"></span> : <span className='profile_status_busy'> </span>} </td>)
    }
}

export class StatusCell extends React.Component<GridCellProps> {

    render() {
        const value = this.props.dataItem[this.props.field as string];
        switch (value) {
            case 'Active': return (<td><span className="status-active-bg">Active</span></td>);
            case 'InActive': return (<td><span className="status-inactive-bg">Inactive</span></td>);
            case 1: return (<td><span className="status-active-bg">Active</span></td>);
            case 0: return (<td><span className="status-inactive-bg">Inactive</span></td>);
            default: return (<td><span className="status-inactive-bg">Inactive</span></td>);
        }
    }
}

export class StatusCellCheck extends React.Component<GridCellProps> {

    render() {
        const value = this.props.dataItem[this.props.field as string];
        switch (value) {
            case true: return (<td><span className="status-active-bg">✓</span></td>);
            case false: return (<td><span className="status-inactive-bg">✓</span></td>);
            default: return (<td><span className="status-inactive-bg">Inactive</span></td>);
        }
    }
}


export class RejectedCell extends React.Component<GridCellProps> {
    render() {
        const value = this.props.dataItem[this.props.field as string];
        switch (value) {
            case 'Active': return (<td><span className="status-active-bg"></span></td>);
            case 'InActive': return (<td><span className="status-inactive-bg">Rejected</span></td>);
            case 1: return (<td><span className="status-active-bg"></span></td>);
            case 0: return (<td><span className="status-inactive-bg">Rejected</span></td>);
            default: return (<td><span className="status-inactive-bg">Rejected</span></td>);
        }
    }
}


export class CheckboxCell extends React.Component<GridCellProps> {
    render() {
        const value = this.props.dataItem["PatientId"];
        return (<td><input type="checkbox" name="rowSelect" value={value} className="form-control" /></td>);
    }
}

export class EncounterStatusCell extends React.Component<GridCellProps> {

    render() {
        const value = this.props.dataItem[this.props.field as string];
        switch (value) {
            case 'Pending': return (<td><span className="status-active-bg">Pending</span></td>);
            case 'Closed': return (<td><span className="status-inactive-bg">Closed</span></td>);
            case 'Open': return (<td><span className="status-open-bg">Open</span></td>);
            case 'Deleted': return (<td><span className="status-inactive-bg">Deleted</span></td>);
            default: return (<td><span className="status-inactive-bg">Inactive</span></td>);
        }
    }
}



export default { DateCell, SwitchCell, StatusCell, CheckboxCell, RejectedCell, StatusCellCheck, EncounterStatusCell }